import React, { useState, useEffect } from 'react';
import ArchiveItemDetail from './ArchiveItemDetail';
import './PhoneLookup.css';

function ImmatLookup({ immatriculation, onOpenDemande }) {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (immatriculation && immatriculation.length >= 4) {
      const timer = setTimeout(() => searchByImmat(), 400);
      return () => clearTimeout(timer);
    } else {
      setData(null);
    }
  }, [immatriculation]);

  const searchByImmat = async () => {
    try {
      setLoading(true);
      const response = await fetch(
        `${process.env.REACT_APP_API_URL || ''}/api/demandes/by-immat/${immatriculation}`,
        {
          headers: {
            'Authorization': `Bearer ${localStorage.getItem('token')}`
          }
        }
      );
      const result = await response.json();
      setData(result);
    } catch (error) {
      console.error('Erreur recherche immatriculation:', error);
    } finally {
      setLoading(false);
    }
  };

  if (!immatriculation || immatriculation.length < 4) return null;
  if (loading) return <div className="phone-lookup">⏳ Recherche...</div>;
  if (!data) return null;

  const hasDemandes = data.demandes && data.demandes.length > 0;
  const hasArchives = data.archives && data.archives.length > 0;

  if (!hasDemandes && !hasArchives) return null;

  return (
    <div className="phone-lookup">
      {hasDemandes && (
        <div className="phone-lookup-section alert">
          <h4>⚠️ Demandes en cours pour cette immatriculation</h4>
          <div className="phone-lookup-list">
            {data.demandes.map(d => (
              <div key={d.id} className="phone-lookup-item">
                <div className="phone-lookup-info">
                  <strong>{d.nom} {d.prenom}</strong>
                  <span>Sujet: {d.sujet}</span>
                  <span>Date: {new Date(d.date_demande).toLocaleDateString('fr-FR')}</span>
                  <span>Responsable: {d.responsable}</span>
                </div>
                <button
                  type="button"
                  className="btn-primary"
                  onClick={() => onOpenDemande(d)}
                >
                  ✏️ Modifier cette demande
                </button>
              </div>
            ))}
          </div>
        </div>
      )}

      {hasArchives && (
        <div className="phone-lookup-section">
          <h4>📦 {data.archives.length} demande(s) archivée(s)</h4>
          <div className="phone-lookup-list">
            {data.archives.slice(0, 5).map(a => (
              <ArchiveItemDetail key={a.id} archive={a} />
            ))}
          </div>
        </div>
      )}
    </div>
  );
}

export default ImmatLookup;
